import { ComminationMessageType } from 'interface';

export class MessageBridge {
    private static waitingList: { id: number; resolve: (value: any) => void }[] = [];
    private static listeners: {
        id: number;
        type: string;
        callback: (value: any) => Promise<any> | void;
    }[] = [];
    static request(type: string, data?: any) {
        return new Promise<any>((resolve, reject) => {
            const id = new Date().getTime();
            this.postMessage({ type, data, id });
            this.waitingList.push({ id, resolve });
        });
    }

    static message(type: string, data?: any) {
        this.postMessage({ type, data });
    }

    private static postMessage(value: any) {
        const newWindow: any = window;
        if (newWindow && newWindow.ReactNativeWebView && newWindow.ReactNativeWebView.postMessage) {
            newWindow.ReactNativeWebView.postMessage(JSON.stringify(value));
        }
    }

    static onMessage(e: any) {
        const stringMessage = e.data;
        let messageObject: ComminationMessageType | undefined = undefined;
        try {
            messageObject = JSON.parse(stringMessage);
        } catch (e) {
            console.log(e);
        }
        if (messageObject?.id) {
            for (const item of this.waitingList) {
                console.warn('message', messageObject);
                if (item.id === messageObject.id) {
                    console.warn('found', item.id);
                    item.resolve(messageObject.data);
                    this.waitingList = this.waitingList.filter((i) => i.id !== item.id);
                    break;
                }
            }
        }
        for (const item of this.listeners) {
            if (item.type === messageObject?.type) {
                const promise = item.callback(messageObject.data);
                if (messageObject && messageObject.id) {
                    if (promise) {
                        promise.then((res) => {
                            this.postMessage({
                                id: messageObject?.id,
                                type: messageObject?.type,
                                data: res,
                            });
                        });
                    } else {
                        this.postMessage({
                            id: messageObject?.id,
                            type: messageObject?.type,
                        });
                    }
                }
            }
        }
    }

    static subscribe(type: string, callback: (value: any) => Promise<any> | void): number {
        const id = new Date().getTime();
        this.listeners.push({ id, type, callback });
        return id;
    }

    static unsubscribe(id: number) {
        this.listeners = this.listeners.filter((i) => i.id !== id);
    }
}
